import * as services from '@services/index';
import {
  ISkinPopularAnswerInfo,
  ISkinDiseaseTypeInfos
} from '../schemas/dermatological-center';

interface IState {
  skinPopularAnswerInfo: ISkinPopularAnswerInfo[];
  skinDiseaseTypeInfos: ISkinDiseaseTypeInfos[];
  skinDiseaseTabs: {
    key: number;
    value: string;
  }[];
}

const initState: IState = {
  skinPopularAnswerInfo: [],
  skinDiseaseTypeInfos: [],
  skinDiseaseTabs: []
};

const dermatologicalCenter = {
  state: initState,

  reducers: {
    updateState(state: IState, payload) {
      return {
        ...state,
        ...payload
      };
    }
  },

  effects: (dispatch) => ({
    async getSkinPopularAnswerInfo() {
      try {
        const res = await services.dermatologicalCenter.getSkinPopularAnswerInfo();
        this.updateState({
          skinPopularAnswerInfo: res
        });
      } catch (err) {
        //
      }
    },
    async getSkinDiseaseTypeInfos() {
      try {
        const res = await services.dermatologicalCenter.getSkinDiseaseTypeInfos();
        this.updateState({
          skinDiseaseTypeInfos: res.result,
          skinDiseaseTabs: res.tabs
        });
      } catch (err) {
        //
      }
    }
  })
};

export default dermatologicalCenter;
